let lastOrientation = window.orientation;
gsap.registerPlugin(ScrollTrigger);
window.addEventListener('load', function () {
  ScrollTrigger.config({ ignoreMobileResize: true });
  if (document.querySelectorAll('.tab__wrapper--js') != null) {
    document.querySelectorAll('.tab__wrapper--js').forEach(function (e) {
      e.addEventListener('click', function () {
        document.querySelector('.tab__content').classList.add('open--tab');
        let tab = e.getAttribute('data-id');
         if (document.querySelector('.product__tab.view') != null) {
          document.querySelector('.product__tab.view').classList.remove('view');
        }
        document.querySelectorAll('.btn__tag').forEach(function(el){
            el.classList.remove('active--item');
        })
        document.querySelector('.btn__tag[data-id="'+tab+'"]').classList.add('active--item');
        document.querySelector('.' + tab).classList.add('view');
        if (document.querySelector('.' + tab + '--img') != null) {
          document.querySelector('.' + tab + '--img').classList.add('view');
        }
      });
    });
    document.querySelectorAll('.tab__close').forEach(function (e) {
      e.addEventListener('click', function () {
        document.querySelector('.tab__content').classList.remove('open--tab');
        document.querySelector('.tab__inner.view').classList.remove('view');
        if (document.querySelector('.product__tab.view') != null) {
          document.querySelector('.product__tab.view').classList.remove('view');
        }
        document.querySelectorAll('.btn__tag').forEach(function(el){
            el.classList.remove('active--item');
        })
      });
    });
    document.querySelectorAll('.tab__background').forEach(function (e) {
      e.addEventListener('click', function () {
        document.querySelector('.tab__content').classList.remove('open--tab');
        document.querySelector('.tab__inner.view').classList.remove('view');
        if (document.querySelector('.product__tab.view') != null) {
          document.querySelector('.product__tab.view').classList.remove('view');
        }
        document.querySelectorAll('.btn__tag').forEach(function(el){
            el.classList.remove('active--item');
        })
      });
    });

    if (document.querySelectorAll('.summary--js') != null) {

        document.querySelectorAll('.summary--js').forEach(function (e) {
        let parent = e.parentNode;
        let sibling = parent.querySelector('.details--js')
        let sh = sibling.offsetHeight;
        sibling.setAttribute('data-h', sh);
        sibling.style.height = '0px';
        e.addEventListener('click', function () {
            console.log('tab');
            parent.classList.toggle('open--tab');
            if(parent.classList.contains('open--tab')){
                let newH = sibling.getAttribute('data-h');
                sibling.style.height = newH+'px';
            }else{
                sibling.style.height = '0px';
            }
        });
        });
    }

  }
  if (document.querySelector('.collection__main__menu') != null) {
    if (this.window.innerWidth > 681) {
      document.querySelector('.collection__main__menu').setAttribute('open', 'open');
    }
  }

/////Sliderrrrr
if(document.querySelector('.home__slide__arrow') != null){
        document.querySelector('.home__slide__arrow.arrow__left').addEventListener('click', function(){
            document.querySelector('.slide-wrp.slide__track').style.transform='translate3d(0,0,0)';
            document.querySelector('.slide-wrp.slide__track .slide1').classList.add('active');
            document.querySelector('.slide-wrp.slide__track .slide1').classList.remove('prev');
            document.querySelector('.slide-wrp.slide__track .slide2').classList.remove('active');
            document.querySelector('.slide-wrp.slide__track .slide2').classList.add('next');
        })
        document.querySelector('.home__slide__arrow.arrow__right').addEventListener('click', function(){
            document.querySelector('.slide-wrp.slide__track').style.transform='translate3d(-100vw,0,0)';
            document.querySelector('.slide-wrp.slide__track .slide1').classList.remove('active');
            document.querySelector('.slide-wrp.slide__track .slide1').classList.add('prev');
            document.querySelector('.slide-wrp.slide__track .slide2').classList.add('active');
            document.querySelector('.slide-wrp.slide__track .slide2').classList.remove('next');
        })
}

    if(document.querySelector('header').classList.contains('announcement__bar--on')){

        document.body.classList.add('announcement__bar--enabled')
    }

});

window.addEventListener('resize', function () {
    if(isMobile()){
        document.querySelector('.collection__main__menu').removeAttribute('open');
        if (typeof currentOrientation !== 'undefined' && currentOrientation !== lastOrientation) {
            lastOrientation = currentOrientation;
            resizeLayout();
            updateAsideHeight();
            ScrollTrigger.refresh();
        }

    }else{
    if (document.querySelector('.collection__main__menu') != null) {
        if (this.window.innerWidth > 681) {
        document.querySelector('.collection__main__menu').setAttribute('open', 'open');
        } else {
        document.querySelector('.collection__main__menu').removeAttribute('open');
        }
    }
    resizeLayout();
    updateAsideHeight();
    ScrollTrigger.refresh();
    }

    if(document.querySelector('.mega__menu') != null){
        let header = document.querySelector('header');
        header.style.height='auto';
        let headerH = header.offsetHeight;
        header.style.height=headerH+'px';
        header.setAttribute('data-h', headerH);
        let total = 0;
        document.querySelectorAll('.mega__menu__inner').forEach(function(e){
            let hit = e.offsetHeight;
            if(hit > total){
                total=hit;
            }
        })
        document.querySelectorAll('.mega__menu__inner').forEach(function(e){
            e.closest('.mega__menu__item').setAttribute('data-h', total);
        })
        document.documentElement.style.setProperty('--header-height', headerH + 'px');
    }

});
window.addEventListener('scroll', function(){
    let y =window.scrollY;
    if(document.querySelector('.collection__grid') != null){
        if(document.querySelector('.collection__grid').getBoundingClientRect().top < 0 && document.querySelector('.collection__grid').getBoundingClientRect().bottom >this.window.innerHeight){
            document.body.classList.add('show--filter');
        }else{
            document.body.classList.remove('show--filter');
        }
    }
    noMenuSection();
    animateHide();
})

function formatPrice(priceInCents, currencyCode = 'EUR') {
  const language = document.documentElement.lang || 'en'; // Por defecto 'en'
  var price = (priceInCents / 100).toFixed(2);
  if (price.endsWith('.00') || price.endsWith(',00')) {
    price = price.replace('.00', '').replace(',00', ''); // Eliminar decimales si son 00
  }
  // Determinar el formato según el idioma
  if (language.startsWith('es') || language.startsWith('fr')) {
    // Formato para español
    return `${price.replace('.', ',')} ${currencyCode}`;
  } else {
    // Formato para inglés o cualquier otro idioma
    return `${currencyCode} ${price}`;
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function newsletterpopup(){
    
}

function updateLocalization({ mark, language }) {
  const formId = crypto.randomUUID();
  if (getCookie('market')) return;
  console.log('mercado', mark, language);
  console.log('shopify', window.Shopify.country, window.Shopify.locale);
  let popup = document.querySelector('.market__modal');
  let market = nameMarket(mark);
  let market2 = nameMarket(window.Shopify.country);
  let lang = (language == 'es' || language =='fr')? language : 'en';

 if (mark != window.Shopify.country) {
  popup.classList.add('show');

  document.querySelector('.market__go').innerHTML =
    '<a href="'+market[0]['url']+'" class="button button--primary" data-m="' + mark + '" data-l="' + lang + '">' +
    market[0][lang] +
    '</a>';
  document.querySelector('.market__stay').innerHTML = '<span>' + market2[0][lang] + '</span>';
  }
  document.querySelector('.market__stay').addEventListener('click', function () {
    popup.classList.remove('show');
  });

  document.querySelector('.market__overlayer').addEventListener('click', function () {
    popup.classList.remove('show');
  });
   
  setCookie('market', true, 1);
  //window.location.href = '/en/';
}
function nameMarket(code) {
  let market;
  if (code == 'ES') {
    market = [{ es: 'España', en: 'Spain', fr: 'Espagne', url:'' }];
  } else if (code == 'UK') {
    market = [{ es: 'Gran bretaña', en: 'United Kingdom', fr: 'Royaume-Uni' , url:''}];
  } else if (code == 'FR') {
    market = [{ es: 'Francia', en: 'France', fr: 'France',url:'' }];
  } else if (code =='AL' || code =='AX' || code =='AT' || code =='AD' || code =='BE' || code =='BY' || code =='BA' || code =='BG' || code =='CZ' || code =='DK' || code =='EE' || code =='FI' || code =='FO' || code =='DE' || code =='GG' || code =='GI' || code =='GR' || code =='HR' || code =='HU' || code =='IE' || code =='IM' || code =='IS' || code =='IT' || code =='JE' || code =='LI' || code =='LT' || code =='LU' || code =='LV' || code =='MC' || code =='ME' || code =='MD' || code =='MK' || code =='MT' || code =='NL' || code =='NO' || code =='PL' || code =='RO' || code =='RS' || code =='RU' || code =='SE' || code =='SI' || code =='SJ' || code =='SK' || code =='SM' || code =='UA' || code =='CH' || code =='VA' ) {
    market = [{ es: 'Europa', en: 'Europe', fr: 'Europe' , url:''}];
  } else if (code == 'PT') {
    market = [{ es: 'Portugal', en: 'Portugal', fr: 'Portugal', url:'' }];  
  } else {
    market = [{ es: 'Global', en: 'All countries', fr: 'Global', url:''}];
  }
  return market;
}

function setCookie(name, value, days) {
  console.log('cooki');
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}
function getCookie(name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function eraseCookie(name) {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('.menu__drawer--wrp');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = document.body.classList.contains('menu--open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        document.body.classList.add('menu--open');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu--open');
        /* !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);*/
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      document.body.classList.add('menu--open');
    });
    summaryElement.setAttribute('aria-expanded', true);
    //trapFocus(this.mainDetailsToggle, summaryElement);
    //document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    document.body.classList.remove('menu--open');
    /* this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      console.log('plplpl');
      details.removeAttribute('open');
      details.classList.remove('menu--open');
    });*/
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelectorAll('.submenu--open').forEach((submenu) => {
      submenu.classList.remove('submenu--open');
    });
    //document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    // removeTrapFocus(elementToFocus);
    // this.closeAnimation(this.mainDetailsToggle);

    //if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu--open');
    parentMenuElement && parentMenuElement.classList.remove('submenu--open');
    document.body.classList.remove('menu--open');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));

    //this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  /*openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu--open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu--opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }*/

  /*closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu--open');
    window.removeEventListener('resize', this.onResize);
  }*/

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class NewsletterModal extends HTMLElement {
  constructor() {
    super();
    const that =  this;
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.querySelector('.modal__overlayer').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') this.hide();
    });
    const time = (this.querySelector('#time').value)?this.querySelector('#time').value: 5000;
    if (!getCookie('newsletter')) {
        setTimeout(function(){that.show()},time)
    }
    
  }

  connectedCallback() {
     
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template--modal');
    popup.classList.add('show');
    // this.setAttribute('open', '');
    // if (popup) popup.loadContent();
    // trapFocus(this, this.querySelector('[role="dialog"]'));
    //window.pauseAllMedia();
  }

  hide() {
    const popup = this.querySelector('.template--modal');
    popup.classList.remove('show');
    setCookie('newsletter', true, 1);
    // document.body.dispatchEvent(new CustomEvent('modalClosed'));
    // this.removeAttribute('open');
    // removeTrapFocus(this.openedBy);
    //window.pauseAllMedia();
  }
}
customElements.define('newsletter-modal', NewsletterModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      //if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

            const images = recommendations.querySelectorAll('img');

            const imagePromises = Array.from(images).map((img) => {
            if (img.complete) {
                return Promise.resolve();
            }
            return new Promise((resolve, reject) => {
                img.addEventListener('load', resolve);
                img.addEventListener('error', reject);
                });
            });

            Promise.all(imagePromises)
            .then(() => {
                console.log('images.loaded')
                 ScrollTrigger.refresh();
            })
            .catch((err) => {
                ScrollTrigger.refresh();
            });

		  
          if (document.querySelector('.glide-related') != null) {
            var glideProduct = new Glide('.glide-related', {
              type: 'slider',
              bound: true,
              startAt: 0,
              rewind: false,
              gap: 0,
              perView: 4,
              breakpoints: {
                2000: { perView: 5 },
                1600: { perView: 4 },
                980: { perView: 3 },
                680: { perView: 2 },
              },
              classes: {
                dragging: 'dragging',
              },
              animationTimingFunc: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
              animationDuration: 500,
            }).mount({ ArrowDisabler });

            glideProduct.on('mount.after', function() {
                ScrollTrigger.refresh();
            })


            checkslideperview();

            document
              .querySelector('.product__slider--related .arrow__left')
              .addEventListener('click', function (event) {
                event.preventDefault();

                glideProduct.go('<');
              });

            document
              .querySelector('.product__slider--related .arrow__right')
              .addEventListener('click', function (event) {
                event.preventDefault();

                glideProduct.go('>');
              });

            window.addEventListener('resize', function () {
				checkslideperview();
				});
			}
	
			
            setTimeout(function() {
                ScrollTrigger.refresh();
            }, 100)
			
    
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

function checkslideperview() {
  let related = document.querySelector('#related--number').value;

  let wv = window.innerWidth;
  if (
    (wv > 2000 && related <= 6) ||
    (wv > 1500 && related <= 5) ||
    (wv > 980 && related <= 4) ||
    (wv > 680 && related <= 2)
  ) {
    document.querySelector('.related__product__slider').classList.add('no--events');
  } else {
    document.querySelector('.related__product__slider').classList.remove('no--events');
  }
  
}

customElements.define('product-recommendations', ProductRecommendations);



class fastadd extends HTMLElement {
  constructor() {
    super();
    var that = this;
    this.container = this.querySelector('.fast__add__container');
    if(this.container== null){
        this.container = this.querySelector('.fast__add__mobile ');
        this.buttonMobile = this.querySelector('.button--mobile');
        this.buttonMobile.addEventListener('click', this.onMobileOpen.bind(this));
    }else{
        this.button = this.querySelector('.fast__add__icon');    
        this.button.addEventListener('click', this.onButtonClick.bind(this));
    }
    

    
    this.variants = this.container.querySelectorAll('.swatch__input');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.variants.forEach(function (v) {
      v.addEventListener('click', that.onButtonClick.bind(that));
    });
    this.parent = this.parentElement;
    if (this.parent.classList.contains('page__product')){
        scrollenddetect();
    }
    window.addEventListener('scroll', function(){
        that.container.classList.remove('open--fast');
        that.container.classList.add('closing--fast');
        setTimeout(function(){that.container.classList.remove('closing--fast');},400)
    })
    this.container.addEventListener('mouseleave',function(){
        that.container.classList.remove('open--fast');
        that.container.classList.add('closing--fast');
        setTimeout(function(){that.container.classList.remove('closing--fast');},400)
    })
  }

  onInputChange(event) {
    /*let par = event.target.closest('.fast__add__container');
    let btn = par.querySelector('.button--fast');
    let btns = btn.querySelector('span');
    let txt = btns.getAttribute('data-t0');
    btn.classList.remove('disabled');
    btns.innerHTML = txt;*/
    onButtonClick(event)
  }

  onMobileOpen(event) {
    let numvar = this.container.querySelectorAll('.swatch__input').length;
    if(numvar >1){
        this.container.classList.toggle('open--fast');
    }else{
       this.container.querySelector('.swatch__input').click();
    }
    
  }

  onButtonClick(event) {
    var par = event.target.closest('fast-add');
    let numvar = this.container.querySelectorAll('.swatch__input').length;
    if(numvar >1){
        this.container.classList.toggle('open--fast');
    }else{
       this.container.querySelector('.swatch__input').click();
    }

    var parId = par.getAttribute('id');
    //var checkedInput = document.querySelector('#' + parId + ' .swatch__input:checked');
    var checkedInput = event.target;
    if (checkedInput) {
      var id = checkedInput.value;
      if (id) {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData();
        par.querySelector('.loading__spinner').classList.remove('hidden');

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        formData.append('quantity', 1);
        formData.append('id', id);

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            let that = this;
            setTimeout(function () {
                if(that.querySelector('.loading__spinner') != null){
                    that.querySelector('.loading__spinner').classList.add('hidden');
                }
            }, 200);
            //this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            //if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            //this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
    }
  }
}
customElements.define('fast-add', fastadd);
class zoomproduct extends HTMLElement {
  constructor() {
   
    super();
    var that = this;
    this.scale=1;
    this.startDistance=0;
    this.translateX = 0;
    this.translateY = 0;
    this.startCenter = { x: 0, y: 0 };
    this.panStart = { x: 0, y: 0 };
    this.lastTouch = { x: 0, y: 0 };
    this.isDragging = false;
    this.container = this.querySelector('.product__media-gallery');
    this.leftButton = this.querySelector('.zoom__arrow--left');
    this.rightButton = this.querySelector('.zoom__arrow--right');
    this.closeButton = this.querySelector('.zoom--close');
    this.images = this.querySelectorAll('.product__media-item').forEach(function(el){
        el.addEventListener('touchstart', (e) => {
            if (isMobile()){
           
            }else{
            if (e.touches.length === 2) {
                that.startDistance = that.getDistance(e.touches);
                that.startCenter = that.getCenter(e.touches);
                that.lastScale = that.scale;
                that.isDragging = false;
            }else if (e.touches.length === 1) {
                that.lastTouchX = e.touches[0].clientX;
                that.lastTouchY = e.touches[0].clientY;
                that.isDragging = true;
            }
            }
        }, { passive: false });
    
    })
    this.images = this.querySelectorAll('.product__media-item')
    this.images.forEach(function(el){
        if (isMobile()){
            
        }else{
            el.addEventListener('touchmove', (e) => {
      
            if (e.touches.length === 1 && that.isDragging && that.scale > 1.5) {
                e.preventDefault();
                const touch = e.touches[0];
                const dx = touch.clientX - that.lastTouchX;
                const dy = touch.clientY - that.lastTouchY;
                that.translateX += dx;
                that.translateY += dy;
                that.lastTouchX = touch.clientX;
                that.lastTouchY = touch.clientY;
                that.updateTransform(el);
            }
                
            }, { passive: false })
        }
    })

    this.querySelectorAll('.product__media-item').forEach(function(el){
        el.addEventListener('touchend', (e) => {
        if (e.touches.length < 2) {
            that.startDistance = 0;
            that.isDragging = false;
            }
        }, { passive: false });
    })
    if(this.leftButton){
    this.leftButton.addEventListener('click', this.onLeftButtonClick.bind(this));
    }
    if(this.rightButton){
        this.rightButton.addEventListener('click', this.onRightButtonClick.bind(this));
    }
    this.closeButton.addEventListener('click', this.onCloseButtonClick.bind(this));
    document.querySelectorAll('.product__image__wrp .product__media-item').forEach(function(e){
        e.addEventListener('click', function(){
     
       document.querySelector('.page__product').classList.add('zoom--active');
       document.querySelector('.page__product').scrollLeft= document.querySelector('.page__product').scrollWidth/2;
       let id=this.getAttribute('data-media-id');
       let zoomEl = that.querySelector('.product__media-item[data-media-id="'+id+'"]');
       zoomEl.classList.add('active');
            if (isMobile()){
                window.zoomEl = new PinchZoom.default(zoomEl, {});
            }
        })
    })
    document.addEventListener('keydown', function(event) {
        if(document.querySelector('.page__product').classList.contains('zoom--active')){
            if (event.key === 'Escape') {
                that.closeButton.click();
            } else if (event.key === 'ArrowLeft') {
                that.leftButton.click();
            } else if (event.key === 'ArrowRight') {
                that.rightButton.click();
            }
        }
    });
        
    
  }
    getDistance(touches) {
     const dx = touches[1].clientX - touches[0].clientX;
      const dy = touches[1].clientY - touches[0].clientY;
      return Math.hypot(dx, dy);
    }
    updateTransform(img) {
        console.log('transX', this.translateX);
        const scaledWidth = img.offsetWidth * this.scale;
        const scaledHeight = img.offsetHeight * this.scale;
        const containerWidth = window.innerWidth;
        const containerHeight = window.innerHeight;

        const minX = Math.min((-scaledWidth + containerWidth), 0);
        const maxY = Math.max((scaledHeight - containerHeight) / 2, 0);
        
        this.translateX = Math.min(Math.max(this.translateX,minX),0)
        this.translateY = Math.min(Math.max(this.translateY, -maxY), maxY);
        
        img.style.transform = `translate(${this.translateX}px, ${this.translateY}px) scale(${this.scale})`;
    }

    getCenter(touches) {
      return {
        x: (touches[0].clientX + touches[1].clientX) / 2,
        y: (touches[0].clientY + touches[1].clientY) / 2
      };
    }
    
    onCloseButtonClick(event){
        if (isMobile()){
			window.zoomEl.destroy();
		}
        document.querySelector('.page__product').classList.remove('zoom--active');
        if(document.querySelector('zoom-product .product__media-item.active')){
        document.querySelector('zoom-product .product__media-item.active').classList.remove('active');
        }
    }
    onLeftButtonClick(event){
        if (isMobile()){
			window.zoomEl.destroy();
		}
       let pos =parseInt(document.querySelector('zoom-product .product__media-item.active').getAttribute('data-pos'));
       let total = parseInt(document.querySelectorAll('zoom-product .product__media-item').length);
       let next = (pos == 1)?total:pos-1;
       document.querySelector('zoom-product .product__media-item.active').classList.remove('active');
       let zoomEl = document.querySelector('zoom-product .product__media-item[data-pos="'+next+'"]')
       zoomEl.classList.add('active')
       if (isMobile()){
            window.zoomEl = new PinchZoom.default(zoomEl, {});
        }
    }
    onRightButtonClick(event){
		if (isMobile()){
			window.zoomEl.destroy();
		}
        let pos =parseInt(document.querySelector('zoom-product .product__media-item.active').getAttribute('data-pos'));
       let total = parseInt(document.querySelectorAll('zoom-product .product__media-item').length);
       let next = (pos == total)?1:pos+1;
       document.querySelector('zoom-product .product__media-item.active').classList.remove('active');
       let zoomEl = document.querySelector('zoom-product .product__media-item[data-pos="'+next+'"]');
       zoomEl.classList.add('active')
       if (isMobile()){
            window.zoomEl = new PinchZoom.default(zoomEl, {});
        } 
    }

}
customElements.define('zoom-product', zoomproduct);

class rotate extends HTMLElement {
  constructor() {
	super();
    if(!isMobile()){
	    this.updateSpeed = this.updateSpeed.bind(this);
    }
	this.rotation = 0;
	this.velocity = 0;
	this.minSpeed = 2;
	this.damping = 0.95;
	this.minScale = 0.6;
	this.maxInset = 20;
	this.maxScale = 1;
	this.scrollTimeout = null;
	this.insetValue = 0; // valor interno para interpolación
  }

  initGsapAnimation() {
    if(!isMobile()){
	this.container = this.querySelector('.rotation');
	this.scaledItems = this.querySelectorAll('.round__item');
    
	gsap.to(this.container, {
	  scrollTrigger: {
		trigger: this,
		start: 'top bottom',
		end: 'bottom top',
		scrub: true,
        //markers:true,
		invalidateOnRefresh: true,
		anticipatePin: 1,
		fastScrollEnd: true,
        onEnter:()=>{ScrollTrigger.refresh()},
		onUpdate: self => {
		  const scrollVel = Math.abs(self.getVelocity());
		  this.velocity += scrollVel * 0.002;

		  const insetPercent = gsap.utils.clamp(
			0,
			this.maxInset,
			scrollVel / 100
		  );

		  this.animateInset(insetPercent);

		  // Reiniciar temporizador para restaurar
		  if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
		  this.scrollTimeout = setTimeout(() => {
			this.restoreInset();
		  }, 200);
		}
	  },
	  ease: "none",
	});
    
	this.updateSpeed();

    }
  }

  animateInset(toValue) {
	gsap.to(this, {
	  insetValue: toValue,
	  duration: 0.6,
	  ease: "power2.out",
	  onUpdate: () => {
		const value = `${this.insetValue}%`;
		gsap.set(this.scaledItems, {
		  clipPath: `inset(${value} ${value} ${value} ${value})`
		});
	  },
	  overwrite: "auto"
	});
  }

  restoreInset() {
	this.animateInset(0);
  }

  updateSpeed() {
	this.velocity *= this.damping;
	if (Math.abs(this.velocity) < this.minSpeed) {
	  this.velocity = (this.velocity < 0 ? -1 : 1) * this.minSpeed;
	}

	this.rotation += this.velocity / 60;
	this.container.style.transform = `rotate(${this.rotation}deg)`;

	requestAnimationFrame(this.updateSpeed);
  }
}


customElements.define('rotate-item', rotate);


class shipingDate extends HTMLElement {
  constructor() {
	super();
    var that = this;
    console.log(this);
    const hoy = new Date();
    const diasLaborales = this.calcularDiasLaborales(hoy, 3);
    const opcionesFecha = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

    const fecha2dias = diasLaborales[1].toLocaleDateString('es-ES', opcionesFecha);
    const fecha3dias = diasLaborales[2].toLocaleDateString('es-ES', opcionesFecha);

    // Mostramos el resultado
    this.innerHTML =
    `<p>Haz tu pedido ahora y recibelo entre el <strong>${fecha2dias}</strong> y el <strong>${fecha3dias}</strong>.</p>`;
  }

   calcularDiasLaborales(inicio, cantidadDias) {
    const resultado = [];
    let fecha = new Date(inicio);
    while (resultado.length < cantidadDias) {
      fecha.setDate(fecha.getDate() + 1);
      const dia = fecha.getDay();
      if (dia !== 0 && dia !== 6) { // Excluye domingo (0) y sábado (6)
        resultado.push(new Date(fecha));
      }
    }
    return resultado;
  }

 
}
customElements.define('shiping-date', shipingDate);

class videoControl extends HTMLElement {
  constructor() {
	super();
    var that = this;
    this.parent = this.parentNode;
    this.video = this.parent.querySelector('video');
    this.button =  this.querySelector('.control--button');
    this.playToggle = this.playToggle.bind(this);
    this.button.addEventListener('click', this.playToggle);
    this.circle = this.querySelector('.video--progress');

    this.radius = this.circle.r.baseVal.value;
    this.circumference = 2 * Math.PI * this.radius;

    // Inicializar dash
    this.circle.style.strokeDasharray = this.circumference;
    this.circle.style.strokeDashoffset = this.circumference;
    this.updateProgress = this.updateProgress.bind(this);
    this.video.addEventListener('timeupdate', this.updateProgress);
    this.video.addEventListener('ended', () => {
      this.circle.style.strokeDashoffset = 0;
      this.button.classList.remove('playing');
    });
  }

  playToggle() {
    if (this.video.paused) {
      this.video.play();
      this.classList.add('playing');
    } else {
      this.video.pause();
      this.classList.remove('playing');
    }
  }
  updateProgress() {
    const progress = this.video.currentTime / this.video.duration;
    const offset = this.circumference * (1 - progress);
    this.circle.style.strokeDashoffset = offset;
  }
}
customElements.define('video-control', videoControl);


class textReveal extends HTMLElement {
  constructor() {
	super();
    var that = this;
    this.section = this.closest(".about__highlight-text__section");
    this.container = this.querySelector('#split-text');
    
    if (!this.section || !this.container) return;
    // Split en líneas, palabras y letras
    const split = new SplitType(that.container, {
        types: 'lines, words, chars',
    });

    this.chars = this.querySelectorAll('.char');
    this.totalScroll = window.innerHeight; // 100vh
    this.step = 1 / this.chars.length;
    }
    initChars(){
    
    const that = this
    gsap.set(this.chars, { opacity: 0.3 });
    var tl;
    if(window.innerWidth >980){
    tl = gsap.timeline({
        scrollTrigger: {
        trigger: that.section,            
        start: "top top",
        end: `+=${that.totalScroll}`,
        scrub: true,
        //markers: true,
        pin: true,                    
        anticipatePin: 1
        }
    });
    }else{
        let lm = that.offsetHeight;
        tl = gsap.timeline({
        scrollTrigger: {
        trigger: that.section,            
        start: "top center",
        end: lm+" center",
        scrub: true,
        //markers: true,                  
        anticipatePin: 1
        }
    });
    }
    // Animar cada letra
     that.chars.forEach((char, i) => {

        tl.to(char, { 
            opacity: 1, 
            duration: that.step / 2 ,
   
            
        }, i * that.step);
    });
    
  }
}
customElements.define('text-reveal', textReveal);

class timeLine extends HTMLElement {
  constructor() {
	super();
    var that = this;
    this.track = this.querySelector(".timeline__track");
	this.items = this.querySelectorAll(".timeline__item");
	
	this.section = this.closest("section");
    this.shopSection = this.closest(".shopify-section");
    this.textBlocks = this.section.querySelectorAll(".timeline__text");
	this.scroller = this.querySelector(".timeline__scroller");
	this.headerContent = this.section.querySelector(".timeline__header .wrp");

	this.totalWidth = 0;
	this.currentActive = 0;
    window.addEventListener('resize', this.resizeTimelineScroller.bind(this));
    }
	resizeTimelineScroller() {
        let that = this;
          if (window.innerWidth >=980){
	  if (this.headerContent && this.scroller) {
        let max=0;
        
        this.headerContent.querySelectorAll('.timeline__text').forEach(function(e,i){
            let h = e.offsetHeight;
            if(h > max){
                max = h;
            }
           
        })
        
		const headerBottom = this.headerContent.getBoundingClientRect().height;
		const availableHeight = window.innerHeight - (headerBottom + max + 56);
        
		this.scroller.style.height = `${availableHeight}px`;
    
        ScrollTrigger.refresh();
       
	  }
          }
	}

    initTimelineScroller() {
          if (window.innerWidth >=980){
        let that = this;
            if (this.headerContent && this.scroller) {
                let max=0;
                
                this.headerContent.querySelectorAll('.timeline__text').forEach(function(e,i){
                    let h = e.offsetHeight;
                    if(h > max){
                        max = h;
                    }
                    console.log('m', max, h)
                })
                
                const headerBottom = this.headerContent.getBoundingClientRect().height;
                const availableHeight = window.innerHeight - (headerBottom + max +56);
                
                this.scroller.style.height = `${availableHeight}px`;
            
                ScrollTrigger.refresh();
                this.updateTimeline();
            }
          }
	}

    calcEnd(){
        const that = this;
        const lastItem = that.items[that.items.length - 1];
	    return lastItem.offsetLeft;
    }

	updateTimeline() {
     
      const that = this;
	  

	  const lastItem = that.items[that.items.length - 1];
	  this.totalWidth = lastItem.offsetLeft;

      this.items.forEach(function(item) {
        item.addEventListener('click', function(){
            let p=parseInt(item.getAttribute('data-index'));
            let ps = (p-1)/(that.items.length -1);
            
            let scY =that.shopSection.offsetTop + (p-1) *item.offsetWidth;
              window.scrollTo({
                top: scY,
				duration: 0.4,
                behavior: 'smooth'
            });
     

        })

      })

	  //ScrollTrigger.getById("timeline-scroll")?.kill();
      if (window.innerWidth >=980){
        ScrollTrigger.create({
            id: "timeline-scroll",
            trigger: that.section,
            start: "top top",
            end: () => `+=${that.calcEnd()}`,
            scrub: true,
            //markers:true,
            pin: true,
            anticipatePin: 1,
            onUpdate: (self) => {
                
                let activeIndex = -1;
                let currentActive = that.currentActive;
                that.items.forEach((item, i) => {
                    const rect = item.getBoundingClientRect();
                    if (rect.left <= 20 && rect.right > 0) {
                    activeIndex = i+1;
                    }
                });
                // Si no se detecta ninguno y estamos al final → forzar último
                if (activeIndex === -1 && Math.abs(self.progress - 1) < 0.01) {
                    activeIndex = that.items.length - 1;
                }

                if (activeIndex !== currentActive && activeIndex !== -1) {
                    currentActive = activeIndex;

                    that.items.forEach((item, i) => {
                    item.classList.toggle("h-active", (i+1) === currentActive);
                    });
                    
                    that.textBlocks.forEach((el, i) => {
                    el.classList.toggle("active", (i+1) === currentActive);
                    });
                }

                // Scroll horizontal real
                gsap.set(that.track, {
                    x: -that.calcEnd() * self.progress
                });
            }
        });
      }
	}   
  
}
customElements.define('time-line', timeLine);


class brandTimeLine extends HTMLElement {
  	constructor() {
		super();
		var that = this;
		this.section = this.closest('.about__brand-evolution__section');
		this.container = this.querySelector(".brand__timeline");
		this.shopSection = this.closest(".shopify-section");
		this.items = this.querySelectorAll(".brand__item");
		this.progressWrapper = this.querySelector(".brand__timeline__progress");
		this.progressBar = this.querySelector(".brand__timeline__bar");
		//window.addEventListener('resize', this.resizeTimeline.bind(this))
		this.previousScroll = 0;
    }

    calcEnd(){
        const that = this;
        const viewportWidth = window.innerWidth;
        const firstItem = that.items[0];
        const lastItem = that.items[that.items.length - 1];
        const lastItemWidth = lastItem.offsetWidth;

        return that.container.offsetLeft + lastItem.offsetLeft + (lastItemWidth / 2) - (viewportWidth / 2);
    }

    initScrollTimeline() {
        const that = this;
        ScrollTrigger.refresh();
       // gsap.killTweensOf(that.container);
        //gsap.killTweensOf(that.progressBar);
        if(window.innerWidth >=980){
        const viewportWidth = window.innerWidth;
        const firstItem = that.items[0];
        const lastItem = that.items[that.items.length - 1];
        const lastItemWidth = lastItem.offsetWidth;

        this.items.forEach(function(item) {
            item.addEventListener('click', function(){
                let p=parseInt(item.getAttribute('data-index'));
                let ps = (p-1)/(that.items.length -1);
                
                let scY =that.shopSection.offsetTop + (p-1) *(item.offsetWidth + 0.12*window.innerWidth) +2;
                window.scrollTo({
                    top: scY,
                    duration: 0.4,
                    behavior: 'smooth'
                });
        

            })

        })

        //const finalOffset = that.container.offsetLeft + lastItem.offsetLeft + (lastItemWidth / 2) - (viewportWidth / 2);

        that.items.forEach(item => item.classList.remove("active"));
        
        gsap.to(that.container, {
        x: () => `-${that.calcEnd()}px`,
        ease: "none",
        scrollTrigger: {
            trigger: that.section,
            start: "top top",
            end: () => `+=${that.calcEnd()}`,
            scrub: true,
            pin: true,
            //markers:true,
            anticipatePin: 1,
			onEnter: () => {
				this.items[0].classList.add("active");
			},
			onLeaveBack: () => {
				this.items[0].classList.remove("active");
			},
            onUpdate: self => {
			  const center = window.innerWidth / 2;
			  const scroll = self.scroll();
			  const isScrollingForward = scroll > that.previousScroll;
			  that.previousScroll = scroll;
			  const containerX = gsap.getProperty(that.container, "x") * -1;
			  that.items.forEach((item, index) => {
				const itemCenter = item.offsetLeft + item.offsetWidth / 2;
				const distanceToCenter = itemCenter - containerX - center;
			
				if (isScrollingForward && distanceToCenter < 0) {
				  item.classList.add("active");
				}
			
				if (!isScrollingForward && distanceToCenter > 0 && index !== 0) {
				  item.classList.remove("active");
				}
			  });
			
			  if (Math.abs(self.progress - 1) < 0.01) {
				const last = that.items[that.items.length - 1];
				last.classList.add("active");
			  }
			}
        }
        });

        const updateProgressWrapper = () => {
        const lastCenter = lastItem.offsetLeft + lastItem.offsetWidth / 2;
        const firstCenter = window.innerWidth / 2;
        const progressWidth = lastCenter - firstCenter;

        that.progressWrapper.style.width = `${progressWidth}px`;
        that.progressWrapper.style.left = `50vw - 1px`;
        };

        updateProgressWrapper();

        gsap.to(that.progressBar, {
        scaleX: 1,
        ease: "none",
        scrollTrigger: {
            trigger: that.section,
            start: "top top",
            end: () => `+=${that.calcEnd()}`,
            scrub: true
        }
        });
        }

    }
    resizeTimeline(){
       const that =  this;
        // Debounce por rendimiento
        clearTimeout(window._timelineResizeTimeout);
        window._timelineResizeTimeout = setTimeout(() => {
            
           that.initScrollTimeline(); // reiniciar todo
           ScrollTrigger.refresh();
        }, 150);

        
    }
}
customElements.define('brand-timeline', brandTimeLine);
/**********************HELPERS ************************/

function ArrowDisabler(Glide, Components) {
  return {
    mount() {
      // Only in effect when rewinding is disabled
      if (Glide.settings.rewind) {
        return;
      }

      Glide.on(['mount.after', 'run'], () => {
        // Filter out arrows_control

        let par = Components.Html._r.closest('.product__slider--related');

        // Set left arrow state
        var left = par.querySelector('.arrow__left');
        if (left) {
          if (Glide.index === 0) {
            left.setAttribute('disabled', ''); // Disable on first slide
          } else {
            left.removeAttribute('disabled'); // Enable on other slides
          }
        }

        // Set right arrow state
        var right = par.querySelector('.arrow__right');
        if (right) {
          // Glide.index is based on the active slide
          // For bound: true, there will be no empty space & the last slide will never become active
          // Hence add perView to correctly calculate the last slide
          const lastSlideIndex = Glide.settings.bound ? Glide.index + (Glide.settings.perView - 1) : Glide.index;

          if (lastSlideIndex === Components.Sizes.length - 1) {
            right.setAttribute('disabled', ''); // Disable on last slide
          } else {
            right.removeAttribute('disabled'); // Disable on other slides
          }
        }
      });
    },
  };
}


function openmainmenu(){
    if(document.querySelector('.mega__menu') != null){
        let header = document.querySelector('header');
        let headerH = header.offsetHeight;
        header.style.height=headerH+'px';
        header.setAttribute('data-h', headerH);
        let total = 0;
        document.querySelectorAll('.mega__menu__inner').forEach(function(e){
            let hit = e.offsetHeight;
            if(hit > total){
                total=hit;
            }
        })
        document.querySelectorAll('.mega__menu__inner').forEach(function(e){
            e.closest('.mega__menu__item').setAttribute('data-h', total);
        })
        document.documentElement.style.setProperty('--header-height', headerH + 'px');

        function openMenu(e){
            let drawer = e.getAttribute('data-menu');
            var wasOpen = document.body.classList.contains('menu--open');
            document.querySelectorAll('.menu__item--js').forEach(function(el){el.classList.remove('active')})
            e.classList.add('active');
            document.body.classList.add('menu--open');
            document.querySelectorAll('.mega__menu__item').forEach(function(el){el.classList.remove('active','mega__menu__item--revealed')});
            var panel = document.querySelector('.mega__menu .'+drawer);
            panel.classList.add('active');
            // Expand header after a frame so panel has rendered height
            requestAnimationFrame(function(){
                var panelH = panel.offsetHeight;
                var headerD = header.getAttribute('data-h');
                header.style.height = (parseInt(headerD) + panelH) + 'px';
                document.documentElement.style.setProperty('--header-height', (parseInt(headerD) + panelH) + 'px');
            });
            // Reveal content: instant when switching tabs (already open),
            // after the open animation (400ms) when opening from closed.
            if(wasOpen){
                requestAnimationFrame(function(){ panel.classList.add('mega__menu__item--revealed'); });
            } else {
                setTimeout(function(){
                    if(panel.classList.contains('active')){ panel.classList.add('mega__menu__item--revealed'); }
                }, 400);
            }
        }

        function closeMenu(){
            document.querySelectorAll('.menu__item--js').forEach(function(el){el.classList.remove('active')});
            document.querySelectorAll('.mega__menu__item').forEach(function(el){el.classList.remove('active','mega__menu__item--revealed')});
            document.body.classList.remove('menu--open');
            document.body.classList.add('menu--closing');
            setTimeout(function(){document.body.classList.remove('menu--closing');},500)
            var headerD = header.getAttribute('data-h');
            header.style.height = parseInt(headerD) + 'px';
            document.documentElement.style.setProperty('--header-height', headerD + 'px');
        }

        var closeTimeout = null;

        document.querySelectorAll('.menu__item--js').forEach(function(e){
            e.addEventListener('click', function(){
                if(closeTimeout){ clearTimeout(closeTimeout); closeTimeout = null; }
                if(e.classList.contains('active')){
                    closeMenu();
                }else{
                    openMenu(e);
                }
            })
            e.addEventListener('mouseenter', function(){
                if(closeTimeout){ clearTimeout(closeTimeout); closeTimeout = null; }
                openMenu(e);
            })
        })

        document.querySelector('.mega__menu').addEventListener('mouseleave', function(){
            closeTimeout = setTimeout(function(){ closeMenu(); }, 200);
        })

        document.querySelector('.mega__menu').addEventListener('mouseenter', function(){
            if(closeTimeout){ clearTimeout(closeTimeout); closeTimeout = null; }
        })
        document.querySelector('.mega__menu--back').addEventListener('click', function(){
            document.querySelectorAll('.mega__menu__item').forEach(function(e){e.classList.remove('active','mega__menu__item--revealed')});
            document.body.classList.remove('menu--open');
            document.body.classList.add('menu--closing');
            setTimeout(function(){document.body.classList.remove('menu--closing');},500)
            let headerD=header.getAttribute('data-h');
            header.style.height=parseInt(headerD) +'px';
            document.documentElement.style.setProperty('--header-height', headerD + 'px');
        })
    }
}

// Warm mega menu images during browser idle so the first open has no grey pop-in
function warmMegaMenuImages(){
    var imgs = document.querySelectorAll('.mega__menu__product-img');
    if(!imgs.length){ return; }
    var warm = function(){
        imgs.forEach(function(img){
            var src = img.getAttribute('src');
            if(src){ var pre = new Image(); pre.src = src; }
        });
    };
    if('requestIdleCallback' in window){
        requestIdleCallback(warm, { timeout: 3000 });
    } else {
        setTimeout(warm, 1500);
    }
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.header__icon--search').forEach(function (e) {
    e.addEventListener('click', function () {
         setTimeout(function(){document.querySelector('.mega__menu--back').click()},100)
      document.querySelector('.predictive-search--wrapper').classList.add('open--search');
      document.body.classList.add('search--modal');
    });
  });
  document.querySelector('.predictive-search--close').addEventListener('click', function () {
    document.querySelector('.predictive-search--wrapper').classList.remove('open--search');
    document.body.classList.remove('search--modal');
  });
  sticky_section();
  openmainmenu();
  warmMegaMenuImages();
  slidingMenu();
  
  if(document.querySelector('rotate-item') !=null){
    document.querySelector('rotate-item').initGsapAnimation();
  }

   if(document.querySelector('time-line') !=null){

    document.querySelector('brand-timeline').initScrollTimeline()
	document.querySelector('time-line').initTimelineScroller();
    document.querySelector('text-reveal').initChars();
    
  }


  
  producParallax();
  heroParallax();
  productArrow();
  updateAsideHeight();
  railes();
  parallaxing();
   
  setTimeout(function(){
    footerLogo();

  
  },500);
  if(document.querySelector('main').classList.contains('page__collection')){ //is collection page
    selectLayout();
  
    document.querySelectorAll('.filter__btn').forEach(function(e){e.addEventListener('click', function(){
            document.body.classList.add('filter--open');
        })
    })
    document.querySelector('.collection__filter__back').addEventListener('click', function(){
        document.body.classList.remove('filter--open');
        setTimeout(function(){document.querySelector('.filter__form').scrollTo(0,0)},200)
    })
    document.querySelector('.filters__close').addEventListener('click', function(){
        document.body.classList.remove('filter--open');
        setTimeout(function(){document.querySelector('.filter__form').scrollTo(0,0)},200)
    })
  }




});




function slidingMenu() {
    const trigger=document.querySelector('.header__nav__trigger');
    const nav = document.querySelector(".header__mobile--main__menu");
    const navItems = nav.querySelectorAll("li");
    trigger.addEventListener('click', function(){
        document.body.classList.toggle('mobile__menu--open')
        if(!document.body.classList.contains('mobile__menu--open')){
            document.querySelectorAll('.dropdown').forEach((dropdown) => {
                dropdown.classList.remove("is-open");
                dropdown.parentElement.classList.remove("slide-out");
            })

            document.querySelectorAll('.submenu--open').forEach((submenu) =>{
                submenu.classList.remove('.submenu--open')
            })
        
        }
    })
    // Agrega la clase 'dropdown' a los <li> que tienen un <ul>
    /*const dropdowns = Array.from(navItems).filter((item) =>
        item.querySelector("ul")
    );
    //dropdowns.forEach((item) => item.classList.add("dropdown"));

    // Agrega el botón "back" al principio de cada submenú
    const submenus = nav.querySelectorAll("ul");
    /*submenus.forEach((ul) => {
        const backBtn = document.createElement("li");
        backBtn.className = "js-back";
        backBtn.textContent = "back";
        ul.insertBefore(backBtn, ul.firstChild);
    });*/

    // Evento para abrir submenú
    document.querySelectorAll('.dropdown').forEach((dropdown) => {
        dropdown.addEventListener("click", function (e) {
        e.stopPropagation();
       // e.preventDefault();
        if(dropdown.parentNode.classList.contains('header__submenu--0')){
            document.querySelector('.header__nav__mobile').classList.add('submenu--open')
        }
        this.classList.add("is-open");
        this.parentElement.classList.add("slide-out");
        });
    });

    // Evento para volver atrás
    const backButtons = nav.querySelectorAll(".js-back");
    backButtons.forEach((backBtn) => {
   
        backBtn.addEventListener("click", function (e) {
        if(backBtn.parentNode.classList.contains('header__submenu--1')){
            document.querySelector('.header__nav__mobile').classList.remove('submenu--open')
        } 
        e.stopPropagation();
        const isOpenParent = this.closest(".is-open");

        const slideOutParent = this.closest(".slide-out");
        if (isOpenParent) isOpenParent.classList.remove("is-open");
        if (slideOutParent) slideOutParent.classList.remove("slide-out");
        });
    });
    if(window.innerWidth > 981){
        window.addEventListener('scroll', function(){
            if(document.querySelector('.page__product') != null){
                let container = document.querySelector('.product__container');
                let header = document.querySelector('header')
                let mg = container.offsetHeight - window.innerHeight;
                if(isElementFinal(container) && !document.body.classList.contains('scroll--up') ){
                    header.style.position='absolute';
                    header.style.marginTop=mg+'px';
                }else{
                    header.style.position='fixed';
                    header.style.marginTop='0px';
                }
            }
        })
    }
}

function selectLayout(){
    let w = window.innerWidth;
    if(w > 680){
        document.querySelector('.collection__desktop__modes .collection__mode[data-layout="4"]').classList.add('active--mode');
        document.querySelector('.collection__container').classList.add('layout--4');
    } else {
        document.querySelector('.collection__mobile__modes .collection__mode[data-layout="2"]').classList.add('active--mode');
        document.querySelector('.collection__container').classList.add('layout--2');
   	}
      document.querySelectorAll('.collection__mode').forEach(function(e){
        e.addEventListener('click', function(){
            document.querySelectorAll('.collection__mode').forEach(function(ex){ex.classList.remove('active--mode')});
            let layout = e.getAttribute('data-layout');
            e.classList.add('active--mode');
            document.querySelector('.collection__container').classList.forEach(className => {
                if (className.startsWith('layout--')) {
                    document.querySelector('.collection__container').classList.remove(className);
                }
            });
             document.querySelector('.collection__container').classList.add('layout--'+layout);
             ScrollTrigger.refresh();
            
        })
    })
 
}

function resizeLayout(){
    console.log('resize--layout')
    let w = window.innerWidth;
    if(document.querySelector('.collection__mode')!=null){
    let layout = parseInt(document.querySelector('.collection__mode.active--mode').getAttribute('data-layout'));
    if(w > 1180){
		document.querySelector('.collection__desktop__modes .collection__mode[data-layout="4"]').click()
 	    }else if (w < 680){
			document.querySelector('.collection__mobile__modes .collection__mode[data-layout="2"]').click()
    	}else {
            document.querySelector('.collection__desktop__modes .collection__mode[data-layout="4"]').click()
    	}
		
    }
    ScrollTrigger.refresh();

}


function parallaxing() {

  const images = document.querySelectorAll('.image--parallax');

  images.forEach((img) => {
	const parent = img.closest('.parallax__container');

	function setup() {

	  const imageHeight = img.offsetHeight;
	  const containerHeight = parent.offsetHeight;

	  // Movimiento máximo permitido = imagen extra - contenedor visible
	  const maxMove = imageHeight - containerHeight;

	  if (maxMove <= 0) return; // No hacer parallax si no hay espacio extra

	  // Inicia desde arriba (subida)
	  gsap.set(img, { y: -maxMove });

	  gsap.to(img, {
		y: 0,
		ease: "none",
		scrollTrigger: {
		  trigger: parent,
		  start: "top bottom",
		  end: "bottom top",
		  scrub: true,
          //markers:true,
		  invalidateOnRefresh: true,
		},
	  });
	}
    if(document.body.classList.contains('template__product')){
        let observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (document.body.classList.contains('related--loaded')) {
                setup();
                observer.disconnect(); // Deja de observar una vez que se activa
                break;
            }
            }
        }
        });

        // Configurar qué observar: atributos del body (específicamente cambios en la clase)
        observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
        });

        if (document.body.classList.contains('related--loaded')) {
        setup();
        observer.disconnect();
        }
    }else{
        setTimeout(function(){setup()},100);
    }
   

  });
  
}

function producParallax(){
	let parallaximg = document.querySelectorAll('.product--parallax');
    if(parallaximg){

        parallaximg.forEach(function(img, i){
        let parent=img.closest('.parallax__container');
        let dist = window.innerHeight * 0.2;
        
        //let gap = document.querySelector('header').offsetHeight;

		gsap.set(img,{y: 0});
        
        gsap.to(img, {
            scrollTrigger: {
                trigger:parent,
                start: 'top top',
                end: 'bottom top',
                scrub: true,
                //markers:true,
                invalidateOnRefresh: true,
                anticipatePin:1,
                fastScrollEnd:true
            },
            y: (dist),
			transformOrigin: "top",
            ease: "none",
            onComplete: () => {
                //ScrollTrigger.refresh();
            }
        	});
    	})

    }

}

function heroParallax(){
	let parallaximg = document.querySelectorAll('.hero--parallax');
    if(parallaximg){

        parallaximg.forEach(function(img, i){
        let parent=img.closest('.parallax__container');
        let dist = window.innerHeight * 0.2;
        //let gap = document.querySelector('header').offsetHeight;

		gsap.set(img,{y: 0});
        
        gsap.to(img, {
            scrollTrigger: {
                trigger:parent,
                start: 'top top',
                end: 'bottom top',
                scrub: true,
                //markers:true,
                invalidateOnRefresh: true,
                anticipatePin:1,
                fastScrollEnd:true
            },
            y: (dist),
            opacity: 0.4,
			transformOrigin: "top",
            ease: "none",
            onComplete: () => {
                //ScrollTrigger.refresh();
            }
        	});
    	})

    }

}


function footerLogo(){
  
        let img = document.querySelector('.footer__bottom');
        let himg= img.offsetHeight;
        document.querySelector(':root').style.setProperty('--footer', himg+'px');
        if(img){

            let parent=img.closest('.page__footer');

            gsap.set(img,{opacity: 0});
            
            gsap.to(img, {
                scrollTrigger: {
                    trigger:parent,
                    start: 'top 25%',
                    end: 'bottom bottom',
                    scrub: true,
                    //markers:true,
                    invalidateOnRefresh: true,
                    anticipatePin:1,
                    fastScrollEnd:true
                },
                opacity: 1,
                transformOrigin: "top",
                ease: "none",
                onComplete: () => {
                    //ScrollTrigger.refresh();
                }
            });

        }
 

}


function railes(){
    if(document.querySelector('.product__rail') != null){
        document.querySelectorAll('.product__rail').forEach(function(e){
            let lg= e.querySelector('.track__container').offsetWidth; //ancho del rail
            let dist = lg+window.innerWidth;
            let v = (window.innerWidth > 640)?120: 60;
            let time= (dist /v);
            e.querySelectorAll('.track__container').forEach(function(el){el.style.animationDuration=time+'s'});


        })
    }
    if(document.querySelector('.announcement__rail') != null){
        document.querySelectorAll('.announcement__rail').forEach(function(e){
            let lg= e.querySelector('.announcement__container').offsetWidth; //ancho del rail
            let dist = lg+window.innerWidth;
             let v = (window.innerWidth > 640)?120: 60;
            let time= (dist /v);
            e.querySelectorAll('.announcement__container').forEach(function(el){el.style.animationDuration=time+'s'});


        })
    }

}

function scrollenddetect(){
    var imgcontainer = document.querySelector('.product__media-list');
    var last = imgcontainer.lastChild;
    window.addEventListener('scroll', function(){
        if(isElementFinal(last)){
            document.querySelector('.main').classList.add('hide--float')
        }else{
            document.querySelector('.main').classList.remove('hide--float')
        }
        
    })
}



function isElementFinal(el) {
	var rect     = el.getBoundingClientRect(),
	vWidth   = window.innerWidth || doc.documentElement.clientWidth,
	vHeight  = window.innerHeight || doc.documentElement.clientHeight,
	topHe=(rect.height > vHeight)?rect.height:vHeight;
	// Return false if it's not in the viewport
	if ( rect.bottom < window.innerHeight) {
		return true;
	}
	return false;
}

function productArrow(){
    if(document.querySelector('.product__image__gallery') != null){
        let parent=document.querySelector('.product__image__gallery');
        let arrow = document.querySelector('.product__scroll');
        if(parent.offsetHeight > window.innerHeight*1.1){
        gsap.set(arrow,{opacity: 1});
        gsap.to(arrow, {
            scrollTrigger: {
                trigger:parent,
                start:()=>{
                    const triggerBottom = parent.getBoundingClientRect().bottom;
                    return triggerBottom - window.innerHeight*1.5 +' 50%';
                }, 
                end: ()=>{
                    const triggerBottom = parent.getBoundingClientRect().bottom;
                    return triggerBottom - window.innerHeight +' 50%';
                },
                scrub: true,
                //markers:true,
                invalidateOnRefresh: true,
                anticipatePin: 1,
                fastScrollEnd: true
            },
            opacity:0,
			transformOrigin: "top",
            ease: "none",
            onComplete: () => {

                //ScrollTrigger.refresh();
            }
        	});
        }

        document.querySelector('.product__scroll').addEventListener('click', function(){
            let sc = window.scrollY;
            let wh= window.innerHeight;
            let m = Math.round(sc/wh);
            let go = wh*(m+1);
            window.scrollTo({top: go, behavior: "smooth"})

        })

    }
}

function sticky_section(){

    let section = document.querySelector(".sticky__section__container");
    if(section){
        let tt = document.querySelectorAll('.scrolled__media').length;
        if(!isMobile()){
        // Pinning la sección )
            ScrollTrigger.create({
                trigger: section,
                start: "top top",
                end: "+="+tt*40+"% top", // x pantallas
                //markers: true,
                pin: true,
                scrub: 1,
                onUpdate: self => {
                let progress = self.progress;
                const currentStep = Math.min(Math.floor(progress * tt) + 1, tt);
                
                // Eliminamos las clases previas de step
                for (let i = 1; i <= tt; i++) {
                    section.classList.remove(`step--${i}`);
                }
                
                // Añadimos la clase correspondiente
                section.classList.add(`step--${currentStep}`);
                }
            });
        }else{
                let target = document.querySelector('.scroll__module');
                let textArr = document.querySelectorAll('.scrolled__text');
                let maxH = 0;
                textArr.forEach((txt)=>{
                    if(txt.offsetHeight > maxH) maxH = txt.offsetHeight;
                })
                target.style.height = (maxH + 80) + 'px';
        }

        document.querySelectorAll('.btn__tag.tab__st--js').forEach(function(btn,index) {
            btn.addEventListener('click', function() {
                const section = document.querySelector('.sticky__section');
                const sectionCont = document.querySelector('.sticky__section__container');
                //const partHeight = section.offsetHeight / 3;
                if(isMobile()){
                    sectionCont.classList.forEach(cls => {

                    if (/^step--\d+$/.test(cls)) {
                        sectionCont.classList.remove(cls);
                        }
                    });
                    sectionCont.classList.add('step--'+(parseInt(index)+1))
                }else{
                    let dev = (tt*40/(tt-1))/100;
                    const partHeight= section.querySelector('.scrolled__media').offsetHeight*dev;
                    var scrollToPosition = section.offsetTop + index * partHeight;
                        window.scrollTo(0,scrollToPosition)
                    
                }
            })

        })
    }
}


function noMenuSection() {
  const noMenuElements = document.querySelectorAll('.no--menu');

  if (noMenuElements.length === 0) return;

  let oneIsVisible = false;

  noMenuElements.forEach(function (el) {
	if (isElementVisible(el, 0)) {
	  oneIsVisible = true;
	}
  });

  document.body.classList.toggle('hide--menu', oneIsVisible);
}

function updateAsideHeight() {
  const asideHeader = document.querySelector('.product-aside__header');
  if (asideHeader) {
    const headerHeight = asideHeader.offsetHeight;
    document.documentElement.style.setProperty('--aside-height', `${headerHeight}px`);
  }
}

function touchdevice(){
	var isTouchDevice = (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0))

	if (isTouchDevice) {
			return true;
		} else {
			return false;
		}	
}

function isMobileBrowse(){
	const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];
    
    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
}

function isMobile(){
	if(isMobileBrowse() && touchdevice()){
		return true;
	}else{
		return false;
	}
}

function isElementVisible(el, dist) {
	var rect     = el.getBoundingClientRect(),
	vWidth   = window.innerWidth || doc.documentElement.clientWidth,
	vHeight  = window.innerHeight || doc.documentElement.clientHeight,
	topHe=(rect.height > vHeight)?rect.height:vHeight;
	// Return false if it's not in the viewport
	if (rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight-dist) {
		return false;
	}
	// Return true if any of its four corners are visible
	return true;
}

function animateHide(){
	var h=window.innerHeight;
	var w=window.innerWidth;
	var dist = (w > 681)?200:80;
	document.querySelectorAll('.hide').forEach(function(el,i){
		if(isElementVisible(el, dist)){
			if(el.classList.contains('hide')){el.classList.remove('hide');}
		}
	});
		
}

function isSafariOnMac() {
  const ua = navigator.userAgent;
  const isMac = ua.includes("Macintosh");
  const isSafari = ua.includes("Safari") && !ua.includes("Chrome") && !ua.includes("Chromium") && !ua.includes("Edg");
  return isMac && isSafari;
}

function isSafariOniOS() {
  const ua = navigator.userAgent;
  const platform = navigator.platform;
  const isIOS = /iPhone|iPad|iPod/.test(ua) || 
                (platform === 'MacIntel' && navigator.maxTouchPoints > 1); 
  const isSafari = /^((?!chrome|android|crios|fxios|opios).)*safari/i.test(ua);
  return isIOS && isSafari;
}